(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mm-customer-reviews')) {
  customElements.define('mm-customer-reviews', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.setup()); }
    setup() {
      this.track = this.querySelector('[data-review-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.querySelectorAll('[data-carousel-card]'));
      this.controls = this.querySelector('[data-carousel-controls]');
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      this.hint = this.querySelector('[data-swipe-hint]');
      this.cards = Array.from(this.querySelectorAll('[data-review-card]')).map(card => ({card, quote:card.querySelector('.mr-quote'), button:card.querySelector('[data-review-toggle]')})).filter(item => item.quote && item.button);
      this.handleClick = event => {
        if (event.target.closest('[data-carousel-prev]')) { this.move(-1); return; }
        if (event.target.closest('[data-carousel-next]')) { this.move(1); return; }
        const button = event.target.closest('[data-review-toggle]');
        const item = this.cards.find(entry => entry.button === button);
        if (item) this.expand(item, button.getAttribute('aria-expanded') !== 'true');
      };
      this.handleKey = event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1); }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); this.go(event.key === 'Home' ? 0 : this.track.scrollWidth); }
      };
      this.handleSelect = event => {
        const slide = this.slides.find(card => card === event.target || card.contains(event.target));
        if (!slide) return;
        const item = this.cards.find(entry => entry.card === slide);
        if (item) this.expand(item, true);
        const rect = slide.getBoundingClientRect(), view = this.track.getBoundingClientRect();
        if (rect.left < view.left || rect.right > view.right) this.go(rect.left - view.left + this.track.scrollLeft);
      };
      this.updateNavigation = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const overflow = max > 2;
        this.controls.hidden = !overflow;
        if (this.hint) this.hint.hidden = !overflow;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      };
      this.refresh = () => {
        this.cards.forEach(item => {
          if (item.button.getAttribute('aria-expanded') === 'true') return;
          item.quote.classList.add('is-collapsed');
          const overflow = item.quote.scrollHeight > item.quote.clientHeight + 2;
          item.button.hidden = !overflow;
          if (!overflow) item.quote.classList.remove('is-collapsed');
        });
        this.updateNavigation();
      };
      this.addEventListener('click', this.handleClick);
      this.track.addEventListener('keydown', this.handleKey);
      this.track.addEventListener('scroll', this.updateNavigation, {passive:true});
      document.addEventListener('shopify:block:select', this.handleSelect);
      this.classList.add('mr-ready');
      this.refresh();
      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(this.refresh);
        this.observer.observe(this.track);
        this.cards.forEach(item => this.observer.observe(item.quote));
      } else { window.addEventListener('resize', this.refresh); }
      if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.refresh(); });
    }
    go(left) {
      const reduced = !window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({left:Math.max(0, Math.min(left, this.track.scrollWidth - this.track.clientWidth)), behavior:reduced ? 'auto' : 'smooth'});
    }
    move(direction) {
      const base = this.track.getBoundingClientRect().left;
      const positions = this.slides.map(card => card.getBoundingClientRect().left - base + this.track.scrollLeft);
      const current = this.track.scrollLeft;
      const target = direction > 0 ? positions.find(left => left > current + 5) : positions.reverse().find(left => left < current - 5);
      this.go(target === undefined ? (direction > 0 ? this.track.scrollWidth : 0) : target);
    }
    expand(item, expanded) {
      item.button.setAttribute('aria-expanded', String(expanded));
      item.button.firstChild.textContent = expanded ? item.button.dataset.less : item.button.dataset.more;
      item.quote.classList.toggle('is-collapsed', !expanded);
      item.button.hidden = false;
      if (!expanded) this.refresh();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.handleClick) this.removeEventListener('click', this.handleClick);
      if (this.track && this.handleKey) this.track.removeEventListener('keydown', this.handleKey);
      if (this.track && this.updateNavigation) this.track.removeEventListener('scroll', this.updateNavigation);
      if (this.handleSelect) document.removeEventListener('shopify:block:select', this.handleSelect);
      if (this.observer) this.observer.disconnect();
      if (this.refresh) window.removeEventListener('resize', this.refresh);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmob-brand"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('shopify:block:select', event => {
  const option = event.target.closest('.mmob-option, .mmob-price-block');
  if (option) {
    const details = option.closest('details');
    if (details) details.open = true;
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmob-navigation"] && !Shopify.designMode) return;
  try {
    

(() => {
  const sync = () => {
    document.querySelectorAll('[data-mmob-navigation]').forEach(nav => {
      let visible = 0;
      nav.querySelectorAll('[data-mmob-target]').forEach(link => {
        const target = document.getElementById(link.dataset.mmobTarget);
        const missing = !target;
        link.hidden = missing;
        if (!missing) visible++;
      });
      nav.hidden = visible === 0 && !(window.Shopify && Shopify.designMode);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once:true }); else sync();
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(sync));
  document.addEventListener('shopify:section:reorder', sync);
})();


  } catch(e) { console.error(e); }
})();
})();
